// extracted by mini-css-extract-plugin
export default {"VisuallyHidden":"webpack-components-core-VisuallyHidden-VisuallyHidden-module__VisuallyHidden"};